import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "case-listing-large__item__description" }

import { onMounted, PropType, ref, watch } from "vue";
import { useBreakpoints } from "@/code/useBreakpoints";
import TressResponsivePicture from "@/components/TressResponsivePicture.vue";
import { IMasonryTile } from "@/models/IMasonryTile";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressCaseListing',
  props: {
  tiles: {
    type: Array as PropType<Array<IMasonryTile>>,
    required: true,
  },
},
  setup(__props) {

const props = __props;


const { isLg } = useBreakpoints();
const columns = ref<number>(3);
const masonryTiles = ref<Array<Array<IMasonryTile>>>();
const calculateLayout = () => {
  masonryTiles.value = [];
  if (columns.value && props.tiles) {
    for (let i = 0; i < columns.value; i++) {
      const ls: Array<IMasonryTile> = [];
      for (let j = 0, k = 0; j < props.tiles.length; j++) {
        if (j % columns.value == i) {
          const tile = props.tiles[j];
          tile.isOdd = (k + i) % 2 === 0;
          ls.push({ ...tile });
          k++;
        }
      }
      masonryTiles.value.push(ls);
    }
  }
};
watch(columns, () => {
  calculateLayout();
});
watch(props, () => {
  calculateLayout();
});
watch(isLg, (val) => {
  if (val) {
    columns.value = 3;
  } else {
    columns.value = 2;
  }
});
onMounted(() => {
  calculateLayout();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(masonryTiles.value, (column) => {
    return (_openBlock(), _createElementBlock("div", {
      key: column,
      class: "case-listing-large__container"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column, (tile) => {
        return (_openBlock(), _createElementBlock("a", {
          key: tile.id,
          class: _normalizeClass([{ 'case-listing-large__item--odd': tile.isOdd, 'case-listing-large__item--even': !tile.isOdd }, "case-listing-large__item"]),
          href: tile.url
        }, [
          (tile.squareImage && tile.landscapeImage)
            ? (_openBlock(), _createBlock(TressResponsivePicture, {
                key: 0,
                class: "case-listing-large__item__picture",
                pictures: tile.isOdd ? tile.squareImage : tile.landscapeImage
              }, null, 8, ["pictures"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h2", null, _toDisplayString(tile.text), 1)
          ])
        ], 10, _hoisted_1))
      }), 128))
    ]))
  }), 128))
}
}

})